const withSoluto = require('@soluto-design/tailwind').default;
const path = require('path');

const figmaJSON = require('./figma/variables.json');
const figmaConfig = require('./figma/config.json');

const { getColorFromSoluto } = require('./src/utils/typography');

const config = withSoluto({
    content: [path.join(__dirname, 'src/**/*.{js,ts,jsx,tsx,mdx}')],
    solutoTheme: {
        figmaJSON,
        figmaConfig,
    },
    theme: {
        extend: {
            backgroundImage: {
                'logo-svg': `url("data:image/svg+xml,%3Csvg width='37' height='36' viewBox='0 0 37 36' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.5 18C0.5 8.05888 8.55888 0 18.5 0C28.4411 0 36.5 8.05888 36.5 18C36.5 27.9411 28.4411 36 18.5 36C8.55888 36 0.5 27.9411 0.5 18Z' fill='white'/%3E%3Cpath d='M20.9822 10.0253L18.7539 14.2737L28.065 14.2484L30.3729 10L20.9822 10.0253Z' fill='%2385F451'/%3E%3Cpath d='M9.36502 14.299L7.13672 18.5473L16.4478 18.5221L18.7557 14.2737L9.36502 14.299Z' fill='%2356BC2F'/%3E%3Cpath d='M20.4471 17.5042L18.2188 21.7526L27.5299 21.7273L29.8378 17.4789L20.4471 17.5042Z' fill='%2385F451'/%3E%3Cpath d='M8.82987 21.7778L6.60156 26.0262L15.9127 26.0009L18.2206 21.7525L8.82987 21.7778Z' fill='%2356BC2F'/%3E%3C/svg%3E%0A")`,
                'location-icon': `url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"%3E%3Cpath fill-rule="evenodd" clip-rule="evenodd" d="M15.2664 17.7977C17.2249 15.6834 19 12.9701 19 10.1818C19 8.26992 18.2572 6.44073 16.9418 5.09552C15.6273 3.75107 13.8492 3 12 3C10.1508 3 8.37273 3.75107 7.05815 5.09552C5.74283 6.44073 5 8.26992 5 10.1818C5 12.9701 6.77507 15.6834 8.73362 17.7977C9.69377 18.8342 10.6572 19.683 11.3815 20.2729C11.6165 20.4643 11.8255 20.6277 12 20.7608C12.1745 20.6277 12.3835 20.4643 12.6185 20.2729C13.3428 19.683 14.3062 18.8342 15.2664 17.7977ZM12 22C12 22 20 16.5455 20 10.1818C20 8.01187 19.1571 5.93079 17.6569 4.3964C16.1566 2.86201 14.1217 2 12 2C9.87827 2 7.84344 2.86201 6.34315 4.3964C4.84285 5.93079 4 8.01187 4 10.1818C4 16.5455 12 22 12 22Z" fill="%231F271B"/%3E%3Cpath fill-rule="evenodd" clip-rule="evenodd" d="M11.9999 11.9092C12.8993 11.9092 13.6666 11.1571 13.6666 10.1819C13.6666 9.20664 12.8993 8.45462 11.9999 8.45462C11.1005 8.45462 10.3333 9.20664 10.3333 10.1819C10.3333 11.1571 11.1005 11.9092 11.9999 11.9092ZM14.6666 10.1819C14.6666 11.6881 13.4727 12.9092 11.9999 12.9092C10.5272 12.9092 9.33325 11.6881 9.33325 10.1819C9.33325 8.67566 10.5272 7.45462 11.9999 7.45462C13.4727 7.45462 14.6666 8.67566 14.6666 10.1819Z" fill="%231F271B"/%3E%3C/svg%3E')`,
                'check-icon': `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z" fill="%231F271B"/><path fill-rule="evenodd" clip-rule="evenodd" d="M16.4125 9.2212C16.6216 9.44907 16.6063 9.80332 16.3785 10.0124L10.7691 15.1599L7.62122 12.2713C7.39335 12.0621 7.37813 11.7079 7.58724 11.48C7.79635 11.2521 8.1506 11.2369 8.37847 11.446L10.7691 13.6398L15.6212 9.18722C15.8491 8.97811 16.2033 8.99332 16.4125 9.2212Z" fill="%231F271B"/></svg>')`,
                'check-icon-light': `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M16.4125 9.2212C16.6216 9.44907 16.6063 9.80332 16.3785 10.0124L10.7691 15.1599L7.62122 12.2713C7.39335 12.0621 7.37813 11.7079 7.58724 11.48C7.79635 11.2521 8.1506 11.2369 8.37847 11.446L10.7691 13.6398L15.6212 9.18722C15.8491 8.97811 16.2033 8.99332 16.4125 9.2212Z" fill="white"/></svg>')`,
                'marker-icon': `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none"><circle cx="2" cy="2" r="2" fill="%231F271B"/></svg>')`,
                'marker-icon-light': `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none"><circle cx="2" cy="2" r="2" fill="white"/></svg>')`,
                'form-chevron-icon': `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M4.7637 7.54513L12.0116 14.793L19.2594 7.54513C19.2838 7.52072 19.3101 7.49936 19.3379 7.48106C19.5319 7.35292 19.7957 7.37427 19.9665 7.54513C20.1618 7.74039 20.1618 8.05697 19.9665 8.25224L12.3651 15.8536C12.2714 15.9474 12.1442 16.0001 12.0116 16.0001C11.879 16.0001 11.7518 15.9474 11.658 15.8536L4.0566 8.25223C3.88727 8.08291 3.86478 7.82234 3.98913 7.62878C4.00817 7.59913 4.03066 7.57106 4.0566 7.54513C4.081 7.52072 4.10731 7.49936 4.13503 7.48106C4.20201 7.43684 4.27728 7.41042 4.35417 7.40181C4.37277 7.39972 4.39146 7.39868 4.41015 7.39868C4.53811 7.39868 4.66607 7.4475 4.7637 7.54513Z" fill="currentColor"/></svg>')`,
                'form-chevron-icon-light': `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M4.7637 7.54513L12.0116 14.793L19.2594 7.54513C19.2838 7.52072 19.3101 7.49936 19.3379 7.48106C19.5319 7.35292 19.7957 7.37427 19.9665 7.54513C20.1618 7.74039 20.1618 8.05697 19.9665 8.25224L12.3651 15.8536C12.2714 15.9474 12.1442 16.0001 12.0116 16.0001C11.879 16.0001 11.7518 15.9474 11.658 15.8536L4.0566 8.25223C3.88727 8.08291 3.86478 7.82234 3.98913 7.62878C4.00817 7.59913 4.03066 7.57106 4.0566 7.54513C4.081 7.52072 4.10731 7.49936 4.13503 7.48106C4.20201 7.43684 4.27728 7.41042 4.35417 7.40181C4.37277 7.39972 4.39146 7.39868 4.41015 7.39868C4.53811 7.39868 4.66607 7.4475 4.7637 7.54513Z" fill="white"/></svg>')`,
                'form-chevron-icon-error': `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M4.7637 7.54513L12.0116 14.793L19.2594 7.54513C19.2838 7.52072 19.3101 7.49936 19.3379 7.48106C19.5319 7.35292 19.7957 7.37427 19.9665 7.54513C20.1618 7.74039 20.1618 8.05697 19.9665 8.25224L12.3651 15.8536C12.2714 15.9474 12.1442 16.0001 12.0116 16.0001C11.879 16.0001 11.7518 15.9474 11.658 15.8536L4.0566 8.25223C3.88727 8.08291 3.86478 7.82234 3.98913 7.62878C4.00817 7.59913 4.03066 7.57106 4.0566 7.54513C4.081 7.52072 4.10731 7.49936 4.13503 7.48106C4.20201 7.43684 4.27728 7.41042 4.35417 7.40181C4.37277 7.39972 4.39146 7.39868 4.41015 7.39868C4.53811 7.39868 4.66607 7.4475 4.7637 7.54513Z" fill="%23B83A14"/></svg>')`,
                'form-check-icon': `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.93072 3.07726C10.0261 3.17706 10.0226 3.33531 9.92275 3.43072L4.69198 8.43072C4.59534 8.52309 4.44313 8.52309 4.34649 8.43072L1.57726 5.78366C1.47745 5.68826 1.47388 5.53 1.56928 5.4302C1.66469 5.33039 1.82294 5.32682 1.92275 5.42222L4.51923 7.90416L9.57726 3.06928C9.67706 2.97388 9.83531 2.97745 9.93072 3.07726Z" fill="%231F271B"/></svg>')`,
                'form-check-icon-light': `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.93072 3.07726C10.0261 3.17706 10.0226 3.33531 9.92275 3.43072L4.69198 8.43072C4.59534 8.52309 4.44313 8.52309 4.34649 8.43072L1.57726 5.78366C1.47745 5.68826 1.47388 5.53 1.56928 5.4302C1.66469 5.33039 1.82294 5.32682 1.92275 5.42222L4.51923 7.90416L9.57726 3.06928C9.67706 2.97388 9.83531 2.97745 9.93072 3.07726Z" fill="white"/></svg>')`,
                'block-demo-shape': `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="1033" height="1035" viewBox="0 0 1033 1035" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M414.587 499.544C404.632 555.953 442.193 609.715 498.476 619.631C554.759 629.547 608.459 591.862 618.414 535.454C628.369 479.045 590.807 425.282 534.524 415.367C478.242 405.451 424.542 443.135 414.587 499.544ZM413.681 499.384C403.638 556.29 441.531 610.532 498.317 620.536C555.102 630.54 609.277 592.519 619.32 535.613C629.362 478.707 591.47 424.466 534.684 414.462C477.899 404.458 423.724 442.479 413.681 499.384Z" fill="%2386D959"/><path fill-rule="evenodd" clip-rule="evenodd" d="M294.423 478.374C272.732 601.287 354.578 718.44 477.224 740.047C599.871 761.654 716.884 679.535 738.575 556.623C760.267 433.71 678.421 316.557 555.774 294.949C433.128 273.342 316.115 355.461 294.423 478.374ZM293.518 478.214C271.739 601.624 353.915 719.256 477.065 740.952C600.214 762.648 717.702 680.192 739.481 556.782C761.26 433.372 679.084 315.74 555.934 294.044C432.785 272.349 315.297 354.804 293.518 478.214Z" fill="%2386D959"/><path fill-rule="evenodd" clip-rule="evenodd" d="M163.732 455.35C129.276 650.595 259.286 836.693 454.112 871.017C648.938 905.34 834.812 774.893 869.268 579.648C903.725 384.404 773.714 198.305 578.888 163.982C384.062 129.658 198.189 260.105 163.732 455.35ZM162.826 455.19C128.282 650.933 258.624 837.509 453.952 871.922C649.281 906.334 835.63 775.55 870.174 579.808C904.718 384.066 774.377 197.489 579.048 163.077C383.719 128.665 197.371 259.448 162.826 455.19Z" fill="%2386D959"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.88348 428.07C-40.6974 709.017 146.38 976.804 426.727 1026.19C707.073 1075.58 974.536 887.876 1024.12 606.93C1073.7 325.983 886.62 58.1965 606.273 8.80622C325.927 -40.584 58.4644 147.124 8.88348 428.07ZM7.97783 427.911C-41.6908 709.354 145.718 977.62 426.567 1027.1C707.416 1076.58 975.353 888.533 1025.02 607.089C1074.69 325.646 887.282 57.3802 606.433 7.90135C325.584 -41.5775 57.6465 146.467 7.97783 427.911Z" fill="%2386D959"/><path d="M570.026 615.89C564.553 614.926 560.9 609.698 561.868 604.213C562.836 598.728 568.058 595.063 573.531 596.028C579.005 596.992 582.657 602.22 581.689 607.705C580.721 613.19 575.499 616.854 570.026 615.89Z" fill="%2386D959"/><path d="M430.274 463.269C424.801 462.304 421.148 457.076 422.116 451.591C423.084 446.107 428.306 442.442 433.779 443.406C439.253 444.37 442.905 449.598 441.937 455.083C440.969 460.568 435.747 464.233 430.274 463.269Z" fill="%2386D959"/><path d="M307.014 441.553C301.54 440.589 297.888 435.361 298.856 429.876C299.824 424.391 305.046 420.726 310.519 421.691C315.992 422.655 319.645 427.883 318.677 433.368C317.709 438.853 312.487 442.517 307.014 441.553Z" fill="%2386D959"/><path d="M731.136 459.313C725.663 458.348 722.011 453.12 722.979 447.635C723.947 442.15 729.168 438.486 734.642 439.45C740.115 440.414 743.767 445.642 742.799 451.127C741.831 456.612 736.61 460.277 731.136 459.313Z" fill="%2386D959"/><path d="M840.223 680.771C834.749 679.807 831.097 674.579 832.065 669.094C833.033 663.609 838.255 659.944 843.728 660.909C849.201 661.873 852.854 667.101 851.886 672.586C850.918 678.071 845.696 681.735 840.223 680.771Z" fill="%2386D959"/><path d="M813.928 945.581C808.454 944.617 804.802 939.389 805.77 933.904C806.738 928.419 811.96 924.754 817.433 925.718C822.906 926.683 826.558 931.911 825.59 937.396C824.623 942.88 819.401 946.545 813.928 945.581Z" fill="%2386D959"/><path d="M213.557 721.409C208.084 720.445 204.432 715.217 205.4 709.732C206.368 704.247 211.589 700.583 217.063 701.547C222.536 702.511 226.188 707.739 225.22 713.224C224.252 718.709 219.031 722.374 213.557 721.409Z" fill="%2386D959"/><path d="M145.698 168.651C140.224 167.686 136.572 162.458 137.54 156.973C138.508 151.489 143.73 147.824 149.203 148.788C154.676 149.752 158.328 154.981 157.36 160.465C156.393 165.95 151.171 169.615 145.698 168.651Z" fill="%2386D959"/></svg>')`,
            },
            backgroundPosition: {
                'right-center': 'right 1em top 50%',
            },
            backgroundSize: {
                'block-demo-shape-xs': '632px',
                'block-demo-shape-md': '918px',
                'block-demo-shape-xl': '1033px',
                'notfound-demo-shape-xs': '450px',
                'notfound-demo-shape-md': '571px',
                'notfound-demo-shape-lg': '918px',
                'notfound-demo-shape-xl': '1033px',
            },
            typography: (theme, config, globalconfig) => {
                return {
                    /**
                     * Tailwind Typography’s default styles are opinionated, and
                     * you may need to override them if you have mockups to
                     * replicate. You can view the default modifiers here:
                     *
                     * https://github.com/tailwindlabs/tailwindcss-typography/blob/master/src/styles.js
                     */

                    DEFAULT: {
                        css: [
                            {
                                // '--tw-prose-headings':
                                //     getColorFromSoluto('text-primary'),
                                // '--tw-prose-lead':
                                //     getColorFromSoluto('text-primary'),
                                // '--tw-prose-links':
                                //     getColorFromSoluto('text-secondary'),
                                // '--tw-prose-bold':
                                //     getColorFromSoluto('text-secondary'),
                                // '--tw-prose-counters':
                                //     getColorFromSoluto('text-secondary'),
                                // '--tw-prose-bullets':
                                //     getColorFromSoluto('text-secondary'),
                                '--tw-prose-hr':
                                    getColorFromSoluto('stroke-secondary'),
                                '--tw-prose-quotes':
                                    getColorFromSoluto('text-primary'),
                                '--tw-prose-quote-borders':
                                    getColorFromSoluto('text-primary'),
                                '--tw-prose-captions':
                                    getColorFromSoluto('text-secondary'),
                                '--tw-prose-th-borders':
                                    getColorFromSoluto('stroke-secondary'),
                                '--tw-prose-td-borders':
                                    getColorFromSoluto('stroke-secondary'),

                                /**
                                 * By default, max-width is set to 65 characters.
                                 * This is a good default for readability, but
                                 * often in conflict with client-supplied designs.
                                 * A value of false removes the max-width property.
                                 */
                                maxWidth: false,

                                /**
                                 * Tailwind Typography uses the font weights 400
                                 * through 900. If you’re not using a variable font,
                                 * you may need to limit the number of supported
                                 * weights. Below are all of the default weights,
                                 * ready to be overridden.
                                 */
                                fontWeight:
                                    'var(--soluto-font-b-400-font-weight)',
                                fontSize: 'var(--soluto-font-b-400-font-size)',
                                lineHeight:
                                    'var(--soluto-font-b-400-line-height)',
                                fontFamily:
                                    'var(--soluto-font-b-400-font-family)',
                                p: {
                                    marginTop:
                                        'var(--soluto-font-b-400-line-height)',
                                    marginBottom:
                                        'var(--soluto-font-b-400-line-height)',
                                },
                                a: {
                                    fontWeight: '700',
                                },
                                '[data-btn]': {
                                    fontWeight: '400',
                                    textDecoration: 'none',
                                },
                                strong: {
                                    fontWeight: '700',
                                },
                                ol: {
                                    listStyleType: 'decimal',
                                },
                                ul: {
                                    listStyleType: 'disc',
                                },
                                'ol > li > ol': {
                                    listStyleType: 'lower-latin',
                                },
                                'ol > li::marker': {
                                    fontWeight: '400',
                                },
                                dt: {
                                    fontWeight: '400',
                                },
                                blockquote: {
                                    borderInlineStartWidth: 0,
                                    fontWeight:
                                        'var(--soluto-font-h-400-font-weight)',
                                    fontSize:
                                        'var(--soluto-font-h-400-font-size)',
                                    lineHeight:
                                        'var(--soluto-font-h-400-line-height)',
                                    fontFamily:
                                        'var(--soluto-font-h-400-font-family)',
                                    fontStyle: 'normal',
                                    marginTop: 'var(--soluto-spacing-xxl)',
                                    marginBottom: 'var(--soluto-spacing-xl)',
                                    paddingInlineStart: 0,
                                },
                                'blockquote ': {},
                                h2: {
                                    fontWeight:
                                        'var(--soluto-font-h-400-font-weight)',
                                    fontSize:
                                        'var(--soluto-font-h-400-font-size)',
                                    lineHeight:
                                        'var(--soluto-font-h-400-line-height)',
                                    fontFamily:
                                        'var(--soluto-font-h-400-font-family)',
                                    marginTop: 'var(--soluto-spacing-xxl)',
                                    marginBottom: '24px',
                                },
                                'h2 strong': {
                                    fontWeight: '400',
                                },
                                h3: {
                                    fontWeight:
                                        'var(--soluto-font-b-200-font-weight)',
                                    fontSize:
                                        'var(--soluto-font-b-200-font-size)',
                                    lineHeight:
                                        'var(--soluto-font-b-200-line-height)',
                                    fontFamily:
                                        'var(--soluto-font-b-200-font-family)',
                                    marginTop: 'var(--soluto-spacing-xxl)',
                                    marginBottom: '24px',
                                },
                                kbd: {
                                    fontWeight: '400',
                                },
                                code: {
                                    fontWeight: '400',
                                },
                                pre: {
                                    fontWeight: '400',
                                },
                                hr: {
                                    marginTop: 'var(--soluto-spacing-xg)',
                                    marginBottom: 'var(--soluto-spacing-xg)',
                                },
                                table: {
                                    fontWeight:
                                        'var(--soluto-font-b-400-font-weight)',
                                    fontSize:
                                        'var(--soluto-font-b-400-font-size)',
                                    lineHeight:
                                        'var(--soluto-font-b-400-line-height)',
                                    fontFamily:
                                        'var(--soluto-font-b-400-font-family)',
                                },
                                'thead th': {
                                    fontWeight: '400',
                                },
                                img: {
                                    marginTop: 'var(--soluto-spacing-xl)',
                                    marginBottom: 'var(--soluto-spacing-xl)',
                                    borderRadius: 'var(--soluto-rounded-large)',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                },
                                picture: {
                                    marginTop: 'var(--soluto-spacing-xl)',
                                    marginBottom: 'var(--soluto-spacing-xl)',
                                    borderRadius: 'var(--soluto-rounded-large)',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                },
                                figure: {
                                    marginTop: 'var(--soluto-spacing-xl)',
                                    marginBottom: 'var(--soluto-spacing-xl)',
                                    borderRadius: 'var(--soluto-rounded-small)',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                },
                                video: {
                                    marginTop: 'var(--soluto-spacing-xl)',
                                    marginBottom: 'var(--soluto-spacing-xl)',
                                    borderRadius: 'var(--soluto-rounded-small)',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                },
                                figcaption: {
                                    fontWeight:
                                        'var(--soluto-font-c-200-font-weight)',
                                    fontSize:
                                        'var(--soluto-font-c-200-font-size)',
                                    lineHeight:
                                        'var(--soluto-font-c-200-line-height)',
                                    fontFamily:
                                        'var(--soluto-font-c-200-font-family)',
                                    marginTop: 'var(--soluto-spacing-xs)',
                                    marginBottom: 'var(--soluto-spacing-xs)',
                                },
                            },
                        ],
                    },
                    /**
                     * By default, _tw uses Tailwind Typography’s Neutral gray
                     * scale. If you are adapting an existing design and you need
                     * to set specific colors throughout, you can do so here.
                     */
                    richtext: {
                        css: [
                            {
                                '--tw-prose-body':
                                    getColorFromSoluto('text-secondary'),
                                '--tw-prose-headings':
                                    getColorFromSoluto('text-brand-1'),
                            },
                        ],
                    },
                    post: {
                        css: [
                            {
                                '--tw-prose-body':
                                    getColorFromSoluto('text-primary'),
                                '--tw-prose-bullets':
                                    getColorFromSoluto('text-primary'),
                                '--tw-prose-counters':
                                    getColorFromSoluto('text-primary'),
                                h2: {
                                    fontWeight:
                                        'var(--soluto-font-h-300-font-weight)',
                                    fontSize:
                                        'var(--soluto-font-h-300-font-size) !important',
                                    lineHeight:
                                        'var(--soluto-font-h-300-line-height)',
                                    fontFamily:
                                        'var(--soluto-font-h-300-font-family)',
                                    marginTop: 'var(--soluto-spacing-xxxl)',
                                    marginBottom: '32px',
                                },
                                'h2 strong': {
                                    fontWeight: '400',
                                },
                                'h2 + *': {
                                    marginTop: '32px!important',
                                },
                                h3: {
                                    fontWeight:
                                        'var(--soluto-font-h-400-font-weight)',
                                    fontSize:
                                        'var(--soluto-font-h-400-font-size)',
                                    lineHeight:
                                        'var(--soluto-font-h-400-line-height)',
                                    fontFamily:
                                        'var(--soluto-font-h-400-font-family)',
                                    marginTop: 'var(--soluto-spacing-xxl)',
                                    marginBottom: '24px',
                                },
                                p: {
                                    marginTop: '24px',
                                    marginBottom: '24px',
                                },
                                ol: {
                                    marginTop: '24px',
                                    marginBottom: '24px',
                                },
                                ul: {
                                    marginTop: '24px',
                                    marginBottom: '24px',
                                },
                                'li > p': {
                                    marginTop: 'var(--soluto-spacing-xxs)',
                                    marginBottom: '0',
                                },
                                'li > p + p': {
                                    marginTop: '4px',
                                    marginBottom: 'var(--soluto-spacing-xxs)',
                                },
                                blockquote: {
                                    borderInlineStartWidth: 0,
                                    marginTop: 'var(--soluto-spacing-xxxl)',
                                    marginBottom: 'var(--soluto-spacing-xxxl)',
                                    paddingInlineStart: 0,
                                    position: 'relative',
                                },
                                'blockquote p:first-of-type::before': {
                                    display: 'none',
                                },
                                'blockquote p:last-of-type::after': {
                                    display: 'none',
                                },
                                'blockquote:has(footer)': {
                                    marginTop:
                                        'calc(var(--soluto-spacing-xxxl) + 32px)',
                                },
                                'blockquote:has(footer)::before': {
                                    display: 'block',
                                    position: 'absolute',
                                    content: `url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%2232%22%20height%3D%2225%22%20viewBox%3D%220%200%2032%2025%22%20fill%3D%22none%22%3E%3Cpath%20d%3D%22M7.54078%2024.3625C3.19033%2024.3625%200%2020.8822%200%2016.0483C0%207.15408%205.4139%200.870091%2013.9214%200V2.22356C9.66767%203.19034%205.12387%207.0574%204.93051%2012.2779C10.0544%2010.5378%2013.9214%2013.9215%2013.9214%2017.7885C13.9214%2021.5589%2011.2145%2024.3625%207.54078%2024.3625ZM25.6193%2024.3625C21.2689%2024.3625%2018.0785%2020.8822%2018.0785%2016.0483C18.0785%207.15408%2023.4924%200.870091%2032%200V2.22356C27.7462%203.19034%2023.2024%207.0574%2023.0091%2012.2779C28.1329%2010.5378%2032%2013.9215%2032%2017.7885C32%2021.5589%2029.293%2024.3625%2025.6193%2024.3625Z%22%20fill%3D%22%2363C82D%22/%3E%3C/svg%3E')`,
                                    left: '0',
                                    top: '-32px',
                                    color: getColorFromSoluto('text-brand-1'),
                                },

                                'blockquote > footer > p:last-of-type::after': {
                                    display: 'block',
                                    position: 'absolute',
                                    content: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="32" height="25" viewBox="0 0 32 25" fill="none"><path d="M6.38066 0C10.7311 0 13.9214 3.48036 13.9214 8.3142C13.9214 17.2085 8.50755 23.4924 0 24.3625V22.139C4.35045 21.1722 8.89426 17.3051 8.99094 12.0846C3.86707 13.8248 0 10.4411 0 6.57402C0 2.80362 2.80363 0 6.38066 0ZM24.4592 0C28.8097 0 32 3.48036 32 8.3142C32 17.2085 26.5861 23.4924 18.0785 24.3625V22.139C22.429 21.1722 26.9728 17.3051 27.0695 12.0846C21.9456 13.8248 18.0785 10.4411 18.0785 6.57402C18.0785 2.80362 20.8822 0 24.4592 0Z" fill="%2363C82D"/></svg>')`,
                                    right: '0',
                                    bottom: '0',
                                    color: getColorFromSoluto('text-brand-1'),
                                },
                                'blockquote > p + p': {
                                    marginTop: 'var(--soluto-spacing-xl)',
                                },
                                'blockquote > footer > p': {
                                    marginBottom: '4px',
                                    fontWeight:
                                        'var(--soluto-font-b-300-font-weight)',
                                    fontSize:
                                        'var(--soluto-font-b-300-font-size)',
                                    lineHeight:
                                        'var(--soluto-font-b-300-line-height)',
                                    fontFamily:
                                        'var(--soluto-font-b-300-font-family)',
                                },
                                'blockquote > footer > p + p': {
                                    marginTop: '4px',
                                    fontWeight:
                                        'var(--soluto-font-b-400-font-weight)',
                                    fontSize:
                                        'var(--soluto-font-b-400-font-size)',
                                    lineHeight:
                                        'var(--soluto-font-b-400-line-height)',
                                    fontFamily:
                                        'var(--soluto-font-b-400-font-family)',
                                    color: getColorFromSoluto('text-secondary'),
                                },
                                '[class~="structured-block"]': {
                                    marginTop: 'var(--soluto-spacing-xxxl)',
                                    marginBottom: 'var(--soluto-spacing-xxxl)',
                                },
                                '[class~="structured-block"] > :first-child': {
                                    marginTop: '0 !important',
                                },
                                '[class~="structured-block"] > :last-child': {
                                    marginBottom: '0 !important',
                                },
                                '[class~="structured-block"] p': {
                                    paddingRight: '0 !important',
                                },
                                '[class~="highlight-block"]': {
                                    backgroundColor: getColorFromSoluto(
                                        'background-secondary',
                                    ),
                                    fontWeight:
                                        'var(--soluto-font-h-400-font-weight)',
                                    fontSize:
                                        'var(--soluto-font-h-400-font-size)',
                                    lineHeight:
                                        'var(--soluto-font-h-400-line-height)',
                                    fontFamily:
                                        'var(--soluto-font-h-400-font-family)',
                                    padding: 'var(--soluto-spacing-xg)',
                                    borderRadius:
                                        'var(--soluto-rounded-medium)',
                                },
                                '[class~="featured-block"]': {
                                    fontWeight:
                                        'var(--soluto-font-b-200-font-weight)',
                                    fontSize:
                                        'var(--soluto-font-b-200-font-size)',
                                    lineHeight:
                                        'var(--soluto-font-b-200-line-height)',
                                    fontFamily:
                                        'var(--soluto-font-b-200-font-family)',
                                    paddingLeft: 'var(--soluto-spacing-xs)',
                                    paddingTop: 'var(--soluto-spacing-xxs)',
                                    paddingBottom: 'var(--soluto-spacing-xxs)',

                                    borderLeft: `4px solid ${getColorFromSoluto(
                                        'stroke-brand-1',
                                    )}`,
                                },
                                '[class~="media-block"]': {
                                    marginTop: '32px !important',
                                    marginBottom: '32px !important',
                                },
                                '[class~="media-caption"] > p': {
                                    fontWeight:
                                        'var(--soluto-font-c-200-font-weight)',
                                    fontSize:
                                        'var(--soluto-font-c-200-font-size)',
                                    lineHeight:
                                        'var(--soluto-font-c-200-line-height)',
                                    fontFamily:
                                        'var(--soluto-font-c-200-font-family)',
                                    marginTop: '8px',
                                    marginBottom: '0',
                                },
                                '[class~="media-caption"] > p + p': {
                                    marginTop: '4px',
                                },
                                '[class~="list-block"]': {
                                    padding: 'var(--soluto-spacing-xg)',
                                    backgroundColor: getColorFromSoluto(
                                        'background-secondary',
                                    ),
                                    borderRadius:
                                        'var(--soluto-rounded-medium)',
                                },
                                '[class~="list-block"] > ul > li:first-of-type':
                                    {
                                        marginTop: '0',
                                    },
                                '[class~="list-block"] > ol > li:first-of-type':
                                    {
                                        marginTop: '0',
                                    },
                            },
                        ],
                    },
                };
            },
        },
    },
    plugins: [require('@tailwindcss/typography')],
});

module.exports = config;
